import { FieldType, ViewModelBase } from "@shoothill/core";
import { action } from "mobx";
import { RDDV2FormFileModel } from "./RDDV2FormFileModel";

export class RDDV2FormFileViewModel extends ViewModelBase<RDDV2FormFileModel> {
    constructor(item: RDDV2FormFileModel | null) {
        super(item ? item : new RDDV2FormFileModel());
        this.setDecorators(RDDV2FormFileModel);
    }

    @action
    public reset = () => {
        this.model.reset();
    };

    private isMyModelValid = async (): Promise<boolean> => {
        let isValid = true;
        if ((await this.isModelValid()) === false) {
            isValid = false;
        }

        return isValid;
    };

    public async isFieldValid(fieldName: keyof FieldType<RDDV2FormFileModel>): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
